import {isMobile} from '#core/utils/context-utils.js';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getSportsContentConfigs() {
    return {
        palette: {
            [PALETTE_IDS.EVENT_LIST]: {
                EVENT_LIST_BG: COLOR.BRAND.BACKGROUND4,
                EVENT_LIST_HEADER_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                    fontSize: FONT.SIZE_XLARGE,
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                },
                EVENT_LIST_HEADER_SORT_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND2,
                    textTransform: 'uppercase',
                },
                EVENT_LIST_MARKETS_HEADER_TEXT: COLOR.BRAND.FOREGROUND1,
                EVENT_LIST_HEADER_WITH_SEPARATOR: false,
                EVENT_LIST_MOBILE_HEADER_WITH_SEPARATOR: false,

                EVENT_LIST_MARKETS_DROPDOWN: {
                    SECONDARY_DROPDOWN_BG: COLOR.BRAND.BACKGROUND1,
                    SECONDARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.BACKGROUND1,
                },

                EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                EVENT_LIST_GROUP_NAME_TEXT: COLOR.BRAND.FOREGROUND1,
                EVENT_LIST_GROUP_CLASS_TEXT: COLOR.BRAND.FOREGROUND1,
                EVENT_LIST_ITEM_MORE_MARKETS_BUTTON_TEXT: {
                    color: COLOR.BRAND.FOREGROUND3,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                EVENT_LIST_ITEM_SEPARATOR_COLOR: COLOR.BASE.DIVIDER2,
                EVENT_LIST_GROUP_EVENTS_SEPARATOR_COLOR: COLOR.BASE.DIVIDER2,
            },
            [PALETTE_IDS.EVENT_PAGE]: {
                EVENT_PAGE_VISUALISATION_SELECTOR: {
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND5,
                },
                MARKETS_CATEGORIES_SELECTOR: {
                    PIVOT_TEXT: {
                        fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    PIVOT_SELECTED_TEXT: {
                        fontWeight: FONT.WEIGHT_FUTURA_BOLD,
                        color: COLOR.BRAND.FOREGROUND2,
                    },
                    PIVOT_INDICATOR_BG: COLOR.BRAND.FOREGROUND2,
                },
                MARKETS_GROUPS_SELECTOR_BUTTON_NEW_FEATURE_LABEL_TEXT: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.SPORTS_CONTENT]: {
                SPORT_TABS_PIVOT: {
                    PIVOT_ROW_BG: COLOR.BRAND.BACKGROUND1,
                },
            },
            [PALETTE_IDS.SPORT_PAGE]: {
                SPORT_HEADER_BG: !isMobile() ? COLOR.BRAND.BACKGROUND4 : COLOR.BRAND.BACKGROUND1,
                SPORT_HEADER_TEXT: COLOR.BRAND.FOREGROUND1,

                LEAGUES_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                LEAGUES_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontSize: FONT.SIZE_XLARGE,
                    fontStyle: 'italic',
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                LEAGUES_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontStyle: 'italic',
                    textTransform: 'uppercase',
                    fontSize: FONT.SIZE_XSMALL,
                },
                LEAGUES_ITEM_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontStyle: 'italic',
                    fontWeight: FONT.WEIGHT_BOLD,
                    textTransform: 'uppercase',
                    fontSize: FONT.SIZE_XSMALL,
                },

                EVENT_LIST_SKELETON: {
                    EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND4,
                },
                EVENT_LIST_GROUP_HEADER_ITEM_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND4,
                },
            },
            [PALETTE_IDS.COUPONS]: {
                COUPONS_TITLE_TEXT: {
                    fontFamily: FONT.FAMILY_FUTURA,
                    fontWeight: FONT.WEIGHT_BOLD,
                    fontSize: 20, // according to Zeplin
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                    fontStyle: 'italic',
                    textAlign: 'center',
                },
                TOP_SPORTS_SPORT_SELECTOR_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                TOP_SPORTS_SPORT_SELECTOR: {
                    TOGGLE_BUTTON_BG: COLOR.BRAND.BACKGROUND1,
                    TOGGLE_BUTTON_ICON_COLOR: COLOR.BRAND.ACCENT1,
                },
                TOP_SPORTS_SPORT_SELECTOR_CONTAINER_SEPARATOR_COLOR: COLOR.BRAND.BACKGROUND4,

                MATCHES_FILTER_BUTTON: {
                    TOGGLE_BUTTON_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        textTransform: 'uppercase',
                    },
                },

                PRICE_BOOST_COUPON_BG: COLOR.BRAND.BACKGROUND4,
                PRICE_BOOST_COUPON_EVENT_SEPARATOR_COLOR: COLOR.BASE.DIVIDER2,
            },
            [PALETTE_IDS.HOME_PAGE]: {
                HOME_PAGE_TOP_SPORTS_CONTAINER_BG: COLOR.BRAND.BACKGROUND1,
                HOME_PAGE_TOP_SPORTS_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.FOREGROUND6,
                },
                HOME_PAGE_TOP_SPORTS_SPORT_TEXT: {
                    fontFamily: FONT.FAMILY,
                    fontSize: 10,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontStyle: 'initial',
                    textTransform: 'uppercase',
                },
            },
            [PALETTE_IDS.INPLAY_PAGE]: {
                INPLAY_SPORTS_SELECTOR: {
                    TOGGLE_BUTTON_ICON_COLOR: COLOR.BRAND.ACCENT1,
                },
                INPLAY_SPORTS_SELECTOR_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND4,
                },
            },
        },
    };
}
